import { Component, OnInit } from '@angular/core';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-correction-request-list',
  templateUrl: './correction-request-list.component.html',
  styleUrls: ['./correction-request-list.component.scss']
})
export class CorrectionRequestListComponent implements OnInit {

  // for pagination
  total: number;
  size: number = 10;
  page: number = 1;
  sortingKey: string;
  sortingValue: string;

  correctionRequestList: any;

  constructor(
    private stpRegistrationStorageService: StpRegistrationStorageService,
  ) {}

  ngOnInit(): void {}

  getAllStpCorrectionRequestList(): void {
    this.stpRegistrationStorageService.getAllStpCorrectionRequestList(this.page, this.size, this.sortingKey, this.sortingValue)
      .subscribe({
        next: (res) => {
          this.correctionRequestList = res?.data;
          this.total = res?.count;
        },
      });
  }

  getStatusLabel(data: any): string {
    if (data?.approvalStatusId === 1) {
      return 'Approved';
    }

    if (data?.approvalStatusId === 2) {
      return 'Rejected';
    }

    return 'Pending';
  }

  getStatusClass(data: any): string {
    if (data?.approvalStatusId === 1) {
      return 'badge badge-success';
    }

    if (data?.approvalStatusId === 2) {
      return 'badge badge-danger';
    }

    return 'badge badge-primary';
  }


    onSearch() {
      this.page = 1;
      this.size = 10;
      this.getAllStpCorrectionRequestList();
    }


    onQueryParamsChange(params: NzTableQueryParams): void {
      this.page = params.pageIndex;
      this.size = params.pageSize;
      params.sort.forEach((element) => {
        if (element.value != null) {
          this.sortingKey = element.key;
          this.sortingValue = element.value;
        }
      });

      this.getAllStpCorrectionRequestList();
    }
}
